const Utils = {
  // Converts from degrees to radians.
  toRadians: function (degrees) {
    return (degrees * Math.PI) / 180
  },

  // Converts from radians to degrees.
  toDegrees: function (radians) {
    return (radians * 180) / Math.PI
  },

  mapRange: function (value, low1, high1, low2, high2) {
    return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1)
  },
  lerp: function (v0, v1, t) {
    return v0 * (1 - t) + v1 * t
  },
  roundTo: function (number, round) {
    var resto = number % round
    if (resto <= round / 2) {
      return number - resto
    } else {
      return number + round - resto
    }
  }
}

export default Utils
